import React from 'react';
import { Card, CardContent } from './ui/card';
import { Building2, Wrench, Trees, Snowflake, ClipboardCheck, MessageSquarePlus, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../mock';

const iconMap = {
  Building2,
  Wrench,
  Trees,
  Snowflake,
  ClipboardCheck,
  MessageSquarePlus
};

const Services = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Unsere Leistungen
          </h2>
          <p className="text-xl text-slate-600">
            Von Objektbetreuung bis Winterdienst – wir sind Ihr zuverlässiger Partner für alle Hausmeisterdienstleistungen
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-slate-200 overflow-hidden cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="bg-white rounded-full p-3 shadow-lg">
                      <IconComponent className="w-6 h-6 text-slate-900" />
                    </div>
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 mb-4">
                    {service.description}
                  </p>
                  <Button
                    onClick={scrollToContact}
                    variant="ghost"
                    className="group/btn p-0 h-auto text-slate-900 hover:text-slate-700"
                  >
                    Mehr erfahren
                    <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            onClick={scrollToContact}
            size="lg"
            className="bg-slate-900 hover:bg-slate-800 text-white text-lg px-8 py-6"
          >
            Jetzt unverbindlich anfragen
          </Button>
          <p className="text-slate-600 mt-4">
            Schnelle Terminvergabe • Kostenlose Erstberatung
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
